import { render, staticRenderFns } from "./editbranch.vue?vue&type=template&id=bd86d07a&scoped=true&"
import script from "./editbranch.js?vue&type=script&lang=js&"
export * from "./editbranch.js?vue&type=script&lang=js&"
import style0 from "./editbranch.vue?vue&type=style&index=0&id=bd86d07a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd86d07a",
  null
  
)

export default component.exports